export function removeArrayItemByValue<T extends number | string>(array: T[], value: T): void {
    const index = array.indexOf(value);
    array.splice(index, 1);
}
